import React, { useEffect, useState } from 'react'
import FlexComponent from '../FlexComponent'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { RadioButton } from 'primereact/radiobutton'
import { ErrorMessage, Field } from 'formik'
import { InputTextarea } from 'primereact/inputtextarea'
import './form.css'
import { Dropdown } from 'primereact/dropdown'
import { InputMask } from 'primereact/inputmask'
import axios from '../../utils/axios'
import { syncWithPhoneApp } from '../../utils/urls'
import { useSelector } from 'react-redux'

function GetStarted({ formName, setLanguageSelect, values, errors, touched, handleBlur, handleChange, locationData, ghlUserId, setFieldValue, toast, onContactIdSync }) {
    // console.log(values);

    const [userOptions, setUserOptions] = useState([]);
    const [ghlUserName, setGhlUserName] = useState(null)
    const [syncLoading, setSyncLoading] = useState(false)
    const activePipeline = useSelector((state) => state.user.activePipeline === "null" ? "" : state.user.activePipeline);
    const appPipeline = useSelector((state) => state.user.appPipeline === "null" ? "" : state.user.appPipeline);
    const defaultLanguage = useSelector((state) => state.user.defaultLanguage === "null" ? "" : state.user.defaultLanguage);
    // console.log("activePipeline", activePipeline);
    // console.log("locationData", locationData);
    const activePipelineName = locationData?.find((location) => location.location_id === activePipeline)?.location_name;
    // console.log("activePipelineName", activePipelineName);

    useEffect(() => {
        if (activePipeline && !values.which_homes_for_sale_region) {
            setFieldValue("which_homes_for_sale_region", activePipeline)
        }
        
        if (appPipeline && !values.application_pipeline) {
            setFieldValue("application_pipeline", appPipeline)
        }

        console.log("defaultLanguage", defaultLanguage);

        if (defaultLanguage && !values.language) {
            if(defaultLanguage.includes("English") && defaultLanguage.includes("Spanish")){
                setFieldValue("language", "Spanish & Some English")
            }else if(defaultLanguage.includes("English")){
                setFieldValue("language", "English")
            }else if(defaultLanguage.includes("Other")){
                setFieldValue("language", "Other")
            }
        }
    }, [activePipeline, appPipeline, defaultLanguage])

    useEffect(() => {

        if (ghlUserId) {
            handleChange('application_by')(ghlUserId)
            setGhlUserName(findFullNameById(ghlUserId))
        }
        const selectedLocation = values.which_homes_for_sale_region;
        const selectedLocationData = locationData?.find((location) => location.location_id === selectedLocation);
        const options = selectedLocationData?.users?.map((user) => ({
            label: user.full_name || user.name,
            value: user.user_id,
        })) || [];
        setUserOptions(options);
    }, [locationData, values.which_homes_for_sale_region, ghlUserId]);

    const findFullNameById = (userId) => {
        if (locationData) {
            for (let location of locationData) {
                for (let user of location.users) {
                    if (user.user_id === userId) {
                        return user.full_name;
                    }
                }
            }
        }
        return null; // Return null if the user is not found
    };

    const leadDetailsOnclick = async () => {
        try {
            setSyncLoading(true)
            const cleaned = values.cell_phone_number.replace(/\D/g, '');
            const formattedNo = `+1${cleaned}`;
            let data = {
                email: values.email,
                phone: cleaned ? formattedNo : ""
            }
            const response = await axios.post(syncWithPhoneApp, data, {
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.status === 200) {
                let data = response.data
                console.log("data", data);

                setFieldValue("firstName", data.first_name)
                setFieldValue("middleName", data.middle_name)
                setFieldValue("lastName", data.last_name)
                setFieldValue("lead_source", data.source)
                setFieldValue("prospecting_account", data.location_name)
                if (data.phone) {
                    const phone = data.phone;
                    const formatted = phone.replace("+1", "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
                    console.log("formatted", formatted);
                    setFieldValue("cell_phone_number", formatted)
                }

                setFieldValue("email", data.email)
                setFieldValue("language", data.language)
                // setFieldValue("which_homes_for_sale_region", data.location_id)
                if (data.contact_id) onContactIdSync?.(data.contact_id)
                setSyncLoading(false)
            }
        } catch (error) {
            setSyncLoading(false)
            toast.current.show({ severity: 'error', summary: '', detail: error?.response?.data?.error, life: 2000 });
        }
    }

    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 5.8%' }} id='getStarted'>
            {/* <div style={{ background: '#08113A' }}>
                <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', color: 'white' }}>I can definitely help. Let's get started!</p>
            </div> */}

            <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start' style={{ padding: "1rem 0" }}>
                <div className='inputContainerDiv' style={{ textAlign: 'start', width: '100%', margin: '0.5rem' }}>
                    <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start'>
                        <div className='inputContainerDiv' style={{ width: '15%' }}>
                            <Field type="text" id="firstName" placeholder="First Name *" name="firstName" className={Boolean((touched.firstName && errors.firstName)) && "fieldErrorShow"} as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                        </div>
                        <div className='inputContainerDiv' style={{ width: '15%' }}>
                            <Field type="text" id="middleName" placeholder="Middle Name" name="middleName" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                        </div>
                        <div className='inputContainerDiv' style={{ width: '15%' }}>
                            <Field type="text" id="lastName" placeholder="Last Name *" name="lastName" className={Boolean((touched.lastName && errors.lastName)) && "fieldErrorShow"} as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                        </div>
                        <div className='inputContainerDiv' style={{ textAlign: 'start', width: '20%' }}>
                            <Dropdown
                                id='language'
                                value={values.language}
                                options={[
                                    { label: 'English', value: 'English', },
                                    { label: 'Spanish', value: 'Spanish' },
                                    { label: 'Spanish & Some English', value: 'Spanish & Some English' },
                                    { label: 'Other', value: 'Other' },
                                ]}
                                style={{ width: '100%', }}
                                className={Boolean((touched.language && errors.language)) && "fieldErrorShow"}
                                onChange={(e) => {
                                    // handleChange('language')(e.value)
                                    handleChange({
                                        target: {
                                            name: `language`,
                                            value: e.value
                                        }
                                    })
                                    setLanguageSelect(e.value)
                                }}
                                // showClear={values.language}
                                onBlur={handleBlur}
                                placeholder='Select Language *'
                            // filter
                            />

                            {values.language === 'Other' && (
                                <div style={{ marginTop: '1.1rem' }}>
                                    <Field type="text" placeholder="Other" id="otherLanguage" name="otherLanguage" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                                </div>
                            )}

                        </div>
                        {formName != "New Loan Set Up App" &&
                            <div className='inputContainerDiv' style={{ textAlign: 'start', width: '30%' }}>
                                <FlexComponent>
                                    <div>Have you been preapproved?</div>
                                    <Dropdown
                                        id='have_you_been_preapproved'
                                        value={values.have_you_been_preapproved}
                                        options={[
                                            { label: 'Yes', value: 'Yes' },
                                            { label: 'No', value: 'No' }
                                        ]}
                                        style={{ width: '100%', }}

                                        onChange={(e) => {
                                            // handleChange('language')(e.value)
                                            handleChange({
                                                target: {
                                                    name: `have_you_been_preapproved`,
                                                    value: e.value
                                                }
                                            })
                                        }}
                                        showClear={values.have_you_been_preapproved}
                                        onBlur={handleBlur}
                                        placeholder='Select'
                                    // filter
                                    />
                                </FlexComponent>
                            </div>

                        }

                    </FlexComponent>

                    <FlexComponent className='inputFlexContainer' justifyContent="start" gap='1rem' alignItems='start'>
                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '15%' }}>
                            <div className={`p-inputgroup flex-1 login-input-div`} style={{ borderRadius: "5px", border: Boolean((touched.cell_phone_number && errors.cell_phone_number)) ? "1px solid red" : "", }} >
                                <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                    <i className='pi pi-mobile' style={{ color: "black", fontWeight: "bold", padding: "5px", borderRadius: "30px" }}></i>
                                </span>
                                <InputMask
                                    mask="(999) 999-9999"
                                    className='inputWithIcon'
                                    type="text"
                                    id="cell_phone_number"
                                    name="cell_phone_number"
                                    value={values.cell_phone_number || null}
                                    onChange={handleChange}
                                    style={{ width: '100%', borderLeft: "none" }}
                                    onBlur={handleBlur}
                                />
                            </div>
                        </div>

                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '16%' }}>
                            <Button disabled={!values.email && !values.cell_phone_number} onClick={() => {
                                leadDetailsOnclick()
                            }} type='button' loading={syncLoading} icon="pi pi-sync" label='Sync With Phone App' style={{ fontSize: "12px", padding: ".83rem .75rem" }} />
                        </div>

                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '20%' }}>
                            <div className={`p-inputgroup flex-1 login-input-div`} style={{ borderRadius: "5px" }} >
                                <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                    <i className='pi pi-envelope' style={{ color: "black", fontWeight: "bold", padding: "5px", borderRadius: "30px" }}></i>
                                </span>
                                <Field type="text" id="email" className='inputWithIcon' placeholder="Email" name="email" as={InputText} style={{ width: '100%', borderLeft: "none" }} onBlur={handleBlur} />
                            </div>

                        </div>

                        <div className='inputContainerDiv' style={{ textAlign: 'start', marginTop: '1.2rem', width: '20%' }}>
                            <Dropdown
                                id='MaritalStatus'
                                value={values.MaritalStatus}
                                options={[
                                    { label: "Single", value: "Single" },
                                    { label: "Married", value: "Married" },
                                ]}
                                style={{ width: '100%' }}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: `MaritalStatus`,
                                            value: e.value
                                        }
                                    })
                                }}
                                showClear={values.MaritalStatus}
                                onBlur={handleBlur}
                                placeholder='Marital Status'
                            />
                        </div>

                        {/* <div className='inputContainerDiv' style={{ textAlign: 'start', marginTop: '1.2rem', width: '30%' }}>
                        </div> */}
                    </FlexComponent>

                    <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start' justifyContent="start" >
                        <div className='inputContainerDiv' style={{ textAlign: 'start', marginTop: '1.2rem', width: '20%' }}>
                            <Dropdown
                                id='lead_source'
                                value={values.lead_source}
                                options={[
                                    { label: "Homes For Sale Lead", value: "Homes For Sale Lead" },
                                    { label: "Lead Derived Referral", value: "Lead Derived Referral" },
                                    { label: "Lead Derived Referral Source", value: "Lead Derived Referral Source" },
                                    { label: "Self Sourced", value: "Self Sourced" },
                                    { label: "Home Help Lead", value: "Home Help Lead" },
                                    { label: "Other", value: "Other" },
                                ]}
                                style={{ width: '100%' }}
                                className={Boolean((touched.lead_source && errors.lead_source)) && "fieldErrorShow"}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: `lead_source`,
                                            value: e.value
                                        }
                                    })
                                }}
                                showClear={values.lead_source}
                                onBlur={handleBlur}
                                placeholder='Source *'
                            />
                        </div>

                        <div className='inputContainerDiv' style={{ textAlign: 'start', marginTop: '1.2rem', width: '25%' }}>
                            <Dropdown
                                id='which_homes_for_sale_region'
                                value={values.which_homes_for_sale_region}
                                options={locationData?.map((location) => ({
                                    label: location.location_name,
                                    value: location.location_id,
                                })) || []}
                                style={{ width: '100%' }}
                                className={Boolean((touched.which_homes_for_sale_region && errors.which_homes_for_sale_region)) && "fieldErrorShow"}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: `which_homes_for_sale_region`,
                                            value: e.value
                                        }
                                    })
                                    setFieldValue("application_pipeline", "")
                                }
                                }
                                showClear={values.which_homes_for_sale_region}
                                onBlur={handleBlur}
                                // placeholder='Which Homes For Sale Region?*'
                                placeholder='Active Pipeline *'
                                filter
                            />
                        </div>
                        <div className='inputContainerDiv' style={{ width: '25%', marginTop: '1.2rem' }}>
                            {/* <label htmlFor='application_pipeline' style={{ fontWeight: 'bold', color: Boolean(touched.application_pipeline && errors.application_pipeline) ? 'red' : '' }}>Application Pipeline *</label> */}
                            <Dropdown
                                id='application_pipeline'
                                value={values.application_pipeline}
                                options={userOptions}
                                style={{ width: '100%' }}
                                className={Boolean((touched.application_pipeline && errors.application_pipeline)) && "fieldErrorShow"}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `application_pipeline`,
                                        value: e.value
                                    }
                                })}
                                showClear={values.application_pipeline}
                                onBlur={handleBlur}
                                placeholder='Application Pipeline *'
                                filter
                            />
                        </div>
                        <div className='inputContainerDiv' style={{ marginTop: '1.2rem', width: '25%' }}>
                            {/* <label htmlFor='application_by' style={{ fontWeight: 'bold', color: Boolean(touched.application_by && errors.application_by) ? 'red' : '' }}>Application By *</label> */}
                            {ghlUserId ?
                                <InputText disabled value={ghlUserName} style={{ width: '100%' }} />
                                :
                                <Dropdown
                                    id='application_by'
                                    value={values.application_by}
                                    options={userOptions}
                                    style={{ width: '100%' }}
                                    className={Boolean((touched.application_by && errors.application_by)) && "fieldErrorShow"}
                                    onChange={(e) => handleChange({
                                        target: {
                                            name: `application_by`,
                                            value: e.value
                                        }
                                    })}
                                    showClear={values.application_by}
                                    onBlur={handleBlur}
                                    placeholder='Application By *'
                                    filter
                                />
                            }
                        </div>

                    </FlexComponent>

                    {values.prospecting_account && <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='center' justifyContent="start" style={{ marginTop: '1.2rem' }} >
                        <div>Prospecting Account</div>
                        <div className='inputContainerDiv' style={{ width: '25%' }}>
                            <InputText disabled value={values.prospecting_account} style={{ width: '100%' }} />
                        </div>

                    </FlexComponent>}

                </div>

            </FlexComponent>

            {formName === "New Loan Set Up App" && <FlexComponent>
                <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                    {/* <label style={{ fontWeight: 'bold' }} htmlFor="file_status">File Status</label> <br /> */}
                    <Dropdown
                        id='file_status'
                        value={values.file_status}
                        options={[
                            { label: 'Documents In', value: 'Documents In' },
                            { label: 'Accepted Offer', value: 'Accepted Offer' },
                            { label: 'In Contract', value: 'In Contract' },
                        ]}
                        style={{ width: '100%' }}
                        onChange={(event) => handleChange({
                            target: {
                                name: `file_status`,
                                value: event.value
                            }
                        })}
                        showClear={values.file_status}
                        onBlur={handleBlur}
                        placeholder='Select File Status'
                        filter
                    />
                </div>

            </FlexComponent>}

        </div>
    )
}

export default GetStarted